import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';
import { MasterDetailList } from '../../../external/MasterDetailApi';

export interface MasterDetailInfo {
  displayItemId: string;
  masterDetailList: Array<MasterDetailList>;
}

export interface masterDetailState {
  result: Array<MasterDetailInfo>;
}

export const initialMasterDetailState: masterDetailState = {
  result: [],
};

export const MasterDetailReducer = reducerWithInitialState(initialMasterDetailState).case(
  actions.fetchMasterDetail,
  (state: masterDetailState, payload: masterDetailState) => {
    return {
      ...state,
      ...payload,
    };
  }
);
